import { Flex, Button, Box } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const NAV_ITEMS = [
  { key: "perfil", label: "Perfil" },
  { key: "estudios", label: "Estudios" },
  { key: "experiencia", label: "Experiencia" },
  { key: "proyectos", label: "Proyectos" },
  { key: "habilidades", label: "Habilidades" },
  { key: "idiomas", label: "Idiomas" },
  { key: "certificados", label: "Certificados" },
  { key: "categorias", label: "Categorías" },
];

export default function AdminLayout({ active, onSelect, children }) {
  const { signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    // Navigate to home FIRST so we leave the protected route before the auth
    // state clears — otherwise ProtectedRoute redirects to /login (race).
    navigate("/");
    await signOut();
  };

  const sidebarBg = "bg.card";
  const borderColor = "border.card";

  return (
    <Flex direction={{ base: "column", md: "row" }} minH="100vh">
      {/* Sidebar */}
      <Box
        bg={sidebarBg}
        borderRight={{ base: "none", md: "1px solid" }}
        borderBottom={{ base: "1px solid", md: "none" }}
        borderColor={borderColor}
        w={{ base: "100%", md: "200px" }}
        flexShrink={0}
        overflowX={{ base: "auto", md: "visible" }}
      >
        <Flex
          direction={{ base: "row", md: "column" }}
          justify={{ base: "flex-start", md: "space-between" }}
          h={{ base: "auto", md: "100%" }}
          p={3}
          gap={2}
        >
          {/* Nav items */}
          <Flex
            direction={{ base: "row", md: "column" }}
            gap={2}
            flex={{ md: 1 }}
            wrap={{ base: "nowrap", md: "nowrap" }}
          >
            {NAV_ITEMS.map((item) => (
              <Button
                key={item.key}
                size="sm"
                variant={active === item.key ? "solid" : "ghost"}
                colorScheme={active === item.key ? "blue" : "gray"}
                onClick={() => onSelect(item.key)}
                justifyContent={{ base: "center", md: "flex-start" }}
                flexShrink={0}
              >
                {item.label}
              </Button>
            ))}
          </Flex>
          {/* Salir button */}
          <Button
            size="sm"
            colorScheme="red"
            variant="outline"
            onClick={handleSignOut}
            flexShrink={0}
            mt={{ md: "auto" }}
          >
            Salir
          </Button>
        </Flex>
      </Box>

      {/* Content area */}
      <Box flex="1" p={{ base: 4, md: 8 }} overflowY="auto">
        {children}
      </Box>
    </Flex>
  );
}
